import React, { useState, useRef } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import analyticsService from '../utils/analytics';

import ios_Walletbtn from '../shared/assets/US-UK_Add_to_Apple_Wallet_RGB_101421.svg';
import android_WalletBtn from '../shared/assets/enGB_add_to_google_wallet_add-wallet-badge.svg';

const useStyles = makeStyles(() => ({
   sotyktu_loader: {
      margin: '20px 0',
      color: '#4933DA !important'
   },
   zeposia_loader: {
      margin: '20px 0',
      color: '#0054A6 !important'
   },
   iphoneBtn: {
      height: '60px',
      margin: '15px',
   },
   androidBtn: {
      height: '60px',
      margin: '15px',
   }
}));

function DownloadBtn(props) {
   const classes = useStyles();
   const navigate = useNavigate();

   const [downloadClicked, setDownloadClicked] = useState(false);

   const downloadLink = useRef();

   const deriveChannel = (cid) => {
      if (cid) {
         if (cid.split("_")[0].toLowerCase() == 'sms') {
            return "SMS";
         } else if (cid.split("_")[0].toLowerCase() == 'e') {
            return "Email";
         } else {
            return "";
         }
      } else {
         return "SMS";
      }
   }

   const addPassHandler = () => {
      setDownloadClicked(true);
      analyticsService.setTrack('AddtoWalletClick', {
         walletName: props.passname,
         memberID: props.passData.member_id,
         cid: props.passData.cid,
         customerID: props.passData.customerID,
         tc: props.passData.tc,
         channel: deriveChannel(props.passData.cid)
      });
      if (props.platform === "iphone") {
         axios({
            url: process.env.BMS_COPAY_GENERATE_APPLE_PASS_API, // url to env file
            method: "POST",
            headers: {
               'x-api-key': process.env.BMS_COPAY_API_KEY
            },
            data: {
               token: props.token
            }
         })
            .then((res) => {
               downloadLink.current.href = res.data.Final_Link;
               downloadLink.current.setAttribute("download", "file.pkpass");
               downloadLink.current.click();
               navigate(`/success`)
            })
            .catch((err) => {
               console.log('err', err)
               navigate(`/error`, { state: { error_type: 'addPass_fail' } })
            });
      } else if (props.platform === "android") {
         axios({
            url: process.env.BMS_COPAY_GENERATE_ANDORID_PASS_API,
            method: "POST",
            headers: {
               'x-api-key': process.env.BMS_COPAY_API_KEY
            },
            data: {
               token: props.token
            }
         })
            .then((res) => {
               downloadLink.current.href = res.data.Final_Link;
               downloadLink.current.setAttribute("download", "file.pkpass");
               downloadLink.current.click();
               navigate(`/success`)
            })
            .catch((err) => {
               navigate(`/error`, { state: { error_type: 'addPass_fail' } })
            });
      }
   }

   const toggleLoader = (product) => {
      switch (product) {
         case 'Sotyktu': return <CircularProgress size={50} className={classes.sotyktu_loader} />
         case 'Zeposia': return <CircularProgress size={50} className={classes.zeposia_loader} />
         default: break;
      }
   }

   return (
      <div>
         {downloadClicked ?
            toggleLoader(props.passname)
            :
            <>
               {props.platform.toLowerCase() === 'iphone' && (
                  <img
                     alt="iphone_btn"
                     className={classes.iphoneBtn}
                     src={ios_Walletbtn}
                     onClick={() => addPassHandler()}
                  />
               )}
               {props.platform.toLowerCase() === 'android' && (
                  <img
                     alt="andorid_btn"
                     className={classes.androidBtn}
                     src={android_WalletBtn}
                     onClick={() => addPassHandler()}
                  />
               )}
               {props.platform.toLowerCase() === 'other' && (
                  <Typography style={{ fontWeight: 800 }} variant='subtitle1'>
                     Navigate to the Wallet email or SMS on your mobile device and follow the steps mentioned to add the Co-Pay Pass to your Wallet.
                  </Typography>
               )}
            </>
         }
         <a ref={downloadLink} />
      </div>
   );
}

export default DownloadBtn;
